import NabanQueryKeys from './NabanQueryKeys';

export const nabanQueryKeys = new NabanQueryKeys('naban');
